import { PageContainer } from '@/components/layout/PageContainer'
import { useAuthStore } from '@/lib/store/authStore'
import { useStoreList } from '@/hooks/useStoreList'
import { StoreListCard } from '@/components/storefront/StoreListCard'

export function StorefrontSettingsGuard({ children }: { children: React.ReactNode }) {
  const storefrontUrl = useAuthStore((s) => s.storefrontUrl)
  const authMode = useAuthStore((s) => s.authMode)
  const activeStorefrontKey = useAuthStore((s) => s.activeStorefrontKey)
  const { data: stores = [] } = useStoreList()

  if (authMode !== 'control_plane') {
    return (
      <PageContainer>
        <div className="p-6">
          <h2 className="text-2xl font-semibold mb-2">Storefront Settings</h2>
          <p className="text-muted-foreground">
            Settings are available in production mode.
          </p>
        </div>
      </PageContainer>
    )
  }

  if (!storefrontUrl) {
    return (
      <PageContainer>
        <div className="p-6">
          <h2 className="text-2xl font-semibold mb-2">Storefront Settings</h2>
          <p className="text-muted-foreground">
            Storefront is not configured for your account. Settings
            will be available after your storefront is provisioned.
          </p>
        </div>
      </PageContainer>
    )
  }

  if (activeStorefrontKey === null && stores.length > 1) {
    return (
      <PageContainer>
        <div className="p-6 space-y-6">
          <div>
            <h2 className="text-2xl font-semibold mb-2">Storefront Settings</h2>
            <p className="text-muted-foreground">
              Select a store from the sidebar to manage its settings.
            </p>
          </div>
          {/* Still show the stores list so merchants can create/edit stores */}
          <StoreListCard />
        </div>
      </PageContainer>
    )
  }

  return <>{children}</>
}
